module.exports = "<mat-nav-list>\r\n  <app-nav-item *ngFor=\"let node of nodes\" [node]=\"node\" [selectedNodes]=\"selectedNodes\">\r\n  </app-nav-item>\r\n</mat-nav-list>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/nav-menu/nav-menu.component.html
// module id = ./src/app/shared/components/nav-menu/nav-menu.component.html
// module chunks = main